import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Star } from 'lucide-react';
import axios from 'axios';
import API_BASE_URL from '../services/api';

const API = `${API_BASE_URL}/api`;

const Membership = () => {
  const [selectedPlan, setSelectedPlan] = useState('basic');
  const [stats, setStats] = useState({ active_members: null, intervention_countries: null, years_experience: null });
  const [prices, setPrices] = useState({ member: 9.99, supporter: 19.99 });

  const membershipPlans = [
    {
      id: 'basic',
      name: 'Membre',
      price: prices.member,
      period: 'mois',
      features: [
        'Accès aux événements et ateliers',
        'Newsletter mensuelle',
        'Accès au groupe communautaire'
      ],
      icon: Star,
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      popular: false
    },
    {
      id: 'supporter',
      name: 'Soutien',
      price: prices.supporter,
      period: 'mois',
      features: [
        'Tous les avantages Membre',
        'Rapport d’impact trimestriel',
        'Badge de soutien sur votre profil'
      ],
      icon: Star,
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      popular: true
    },
    {
      id: 'don_unique',
      name: 'Don unique',
      price: 'libre',
      period: 'unique',
      features: [
        'Montant de votre choix',
        'Reçu fiscal automatique',
        'Email de remerciement'
      ],
      icon: Star,
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      popular: false
    }
  ];

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/site/stats`);
        setStats(res.data || {});
      } catch (e) {
        setStats({ active_members: null, intervention_countries: null, years_experience: null });
      }
    })();
    (async () => {
      try {
        const res = await axios.get(`${API}/payments/v2/config`);
        if (res.data) setPrices({ member: res.data.member_monthly_amount, supporter: res.data.supporter_monthly_amount });
      } catch (e) { /* valeurs par défaut */ }
    })();
  }, []);

  return (
    <>
      <div className="relative z-10 min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-4">Devenir Membre PADAID</h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto mb-8">
            Rejoignez notre communauté d'acteurs du changement et participez 
            concrètement à nos missions humanitaires et de développement.
          </p>
          {/* Stats réelles */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-primary">{stats.active_members ?? '—'}</div>
              <div className="text-muted-foreground">Membres actifs</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-secondary">{stats.intervention_countries ?? '—'}</div>
              <div className="text-muted-foreground">Pays d'intervention</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-accent">{stats.years_experience ?? '—'}</div>
              <div className="text-muted-foreground">Années d'expérience</div>
            </div>
          </div>
        </div>

        {/* Membership Plans */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-8">Choisissez votre engagement</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {membershipPlans.map((plan) => {
              const Icon = plan.icon;
              return (
                <Card 
                  key={plan.id}
                  className={`relative cursor-pointer transition-all duration-300 hover:shadow-lg ${
                    selectedPlan === plan.id 
                      ? 'ring-2 ring-primary border-primary/50' 
                      : 'border-border/50 hover:border-primary/20'
                  } ${plan.popular ? 'scale-105' : ''}`}
                  onClick={() => setSelectedPlan(plan.id)}
                >
                  {plan.popular && (
                    <Badge className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-primary text-primary-foreground">
                      Populaire
                    </Badge>
                  )}
                  <CardHeader className="text-center pb-4">
                    <div className={`w-16 h-16 mx-auto rounded-full ${plan.bgColor} flex items-center justify-center mb-4`}>
                      <Icon className={`h-8 w-8 ${plan.color}`} />
                    </div>
                    <h3 className="text-2xl font-bold">{plan.name}</h3>
                    <div className="text-3xl font-bold">
                      {plan.price === 0 ? (
                        <span className="text-muted-foreground">Gratuit</span>
                      ) : plan.price === 'libre' ? (
                        <span className={plan.color}>Montant libre</span>
                      ) : (
                        <>
                          <span className={plan.color}>{plan.price}€</span>
                          <span className="text-base font-normal text-muted-foreground">/{plan.period}</span>
                        </>
                      )}
                    </div>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-3 mb-6">
                      {plan.features.map((feature, index) => (
                        <li key={index} className="text-muted-foreground">{feature}</li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Membership;